<template>
	<section class="modal j-popup j-omya-popup-2">
		<div class="modal__card" style="width:610px;">
			<div class="modal__image-holder">
				<img src="../../../static/images/maraphones/omya_4.jpg" width="100%" alt="" %>
			</div>
			<div class="modal__main">
				<p class="modal__text modal__text--large bold-font">Уважаемые коллеги!</p>

				<p class="modal__text">
					Следуя за&nbsp;отважным космонавтом, мы&nbsp;проделали огромный путь. Постепенно мы&nbsp;поняли,
					что он&nbsp;сам нашёл верный курс на&nbsp;орбиту. Остаётся последний рывок!
				</p>
				<p class="modal__text">
					Чтобы убедиться, что наш герой не&nbsp;сбился с&nbsp;пути, нам нужно расшифровать
					4&nbsp;финальные зашифрованные координаты и&nbsp;исследовать ещё 4&nbsp;неизведанных
					уголка звёздной системы Эдюсон:
				</p>
				<p class="modal__text">
					1)&nbsp;&nbsp;<span style="letter-spacing:1px;">sep du kvar kvar</span><br />
					2)&nbsp;&nbsp;<span style="letter-spacing:1px;">sep du kvar sep</span><br />
					3)&nbsp;&nbsp;<span style="letter-spacing:1px;">sep du kvar ses</span><br />
					4)&nbsp;&nbsp;<span style="letter-spacing:1px;">sep du kvar nau</span>
				</p>
				<p  class="modal__text">Разгадайте этот шифр и&nbsp;пройдите четыре финальных курса!</p>

				<p class="modal__text">
					Как и&nbsp;ранее, напоминаем про <a
						href="https://downloads.eduson.tv/materials/files/000/010/965/original/Регламент_марафона_Omya_(29.06.26).pdf"
						class="link-btn link-btn--underline bold-font"
						style="color: #58298b;"
						target="_blank"
						rel="noopener noreferrer"
					>правила марафона.</a><br />
					Этот заключительный этап продлится до&nbsp;26 июля. <br>
					Желаем удачи!
				</p>
			</div>
			<div class="text-center" style="background-color: #1a1734;border-radius: 0 0 5px 5px;padding: 40px;">
				<button
					class="regular-btn red-white-btn bold-font j-upd-additional-info j-hide-popup"
					:data-url="upd_additional_info_path"
					data-additional-info="omya_07_26_4"
					type="button"
				>Приступить</button>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'OmyaPopup2',

	props: {
		upd_additional_info_path: ''
	},
}
</script>

